import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import audio from '../../utils/audio';
import BonusInterface from '../../api/BonusInterface';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Emitter from '../../services/EmitterService';
import { EVENT_EMITTER_TYPE } from '../../constants';
import { ACTION_COMMANDS_EVENT_TYPE, ACTION_COMMANDS_FEATURE_GROUP, ACTION_COMMANDS_TYPE } from '../../api/ActionCommandsInterface/constants';
import { debounce } from 'lodash';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var WelcomeBonus = /*#__PURE__*/function (_Component) {
  function WelcomeBonus(props) {
    var _this2;

    _classCallCheck(this, WelcomeBonus);

    _this2 = _callSuper2(this, WelcomeBonus, [props]);

    _this2.eventEmitterOnProcesssedRequest = function () {
      var _this2$props$actionCo, _this2$props$actionCo2, _this2$props$actionCo3, _this2$props$actionCo4, _this2$props$actionCo5, _this2$props$actionCo6, _this2$props$actionCo7, _this2$props$actionCo8, _this2$props$actionCo9, _this2$props$actionCo10, _this2$props$actionCo11, _this2$props$actionCo12;

      Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
        actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
        data: {
          event: ACTION_COMMANDS_EVENT_TYPE.ACCEPT_APP_MODAL,
          modalType: (_this2$props$actionCo = _this2.props.actionCommands) === null || _this2$props$actionCo === void 0 ? void 0 : (_this2$props$actionCo2 = _this2$props$actionCo.modal) === null || _this2$props$actionCo2 === void 0 ? void 0 : _this2$props$actionCo2.modalType,
          triggerExecution: (_this2$props$actionCo3 = _this2.props.actionCommands) === null || _this2$props$actionCo3 === void 0 ? void 0 : (_this2$props$actionCo4 = _this2$props$actionCo3.modal) === null || _this2$props$actionCo4 === void 0 ? void 0 : (_this2$props$actionCo5 = _this2$props$actionCo4.buttons[0]) === null || _this2$props$actionCo5 === void 0 ? void 0 : (_this2$props$actionCo6 = _this2$props$actionCo5.onClickAction) === null || _this2$props$actionCo6 === void 0 ? void 0 : _this2$props$actionCo6.triggerExecution,
          payload: (_this2$props$actionCo7 = _this2.props.actionCommands) === null || _this2$props$actionCo7 === void 0 ? void 0 : (_this2$props$actionCo8 = _this2$props$actionCo7.modal) === null || _this2$props$actionCo8 === void 0 ? void 0 : (_this2$props$actionCo9 = _this2$props$actionCo8.buttons[0]) === null || _this2$props$actionCo9 === void 0 ? void 0 : (_this2$props$actionCo10 = _this2$props$actionCo9.onClickAction) === null || _this2$props$actionCo10 === void 0 ? void 0 : _this2$props$actionCo10.payload,
          isFtueFlow: ((_this2$props$actionCo11 = _this2.props.actionCommands) === null || _this2$props$actionCo11 === void 0 ? void 0 : (_this2$props$actionCo12 = _this2$props$actionCo11.payload) === null || _this2$props$actionCo12 === void 0 ? void 0 : _this2$props$actionCo12.featureGroup) === ACTION_COMMANDS_FEATURE_GROUP.FTUE
        }
      });
    };

    _this2.clickHandler = function () {
      audio.onClick();
      audio.playCoinSfx();
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      QueryParamProxy.modalPromiseAccept();
    };

    _this2.debounceClickHandler = debounce(_this2.clickHandler, 1000);
    _this2.buttonClicked = false;
    return _this2;
  }

  _inherits(WelcomeBonus, _Component);

  return _createClass(WelcomeBonus, [{
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
                  actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
                });
                _context.next = 3;
                return BonusInterface.collectWelcomeBonus();

              case 3:
                response = _context.sent;

                if (response.success) {
                  this.props.setIsWelcomeBonusConsumed(true);
                  this.eventEmitterOnProcesssedRequest();
                  audio.playCoinSfx();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          welcomeBonus = _this$props.welcomeBonus,
          render = _this$props.render;
      var bonusAmount = format(welcomeBonus);
      return render({
        bonusAmount: bonusAmount,
        clickHandler: this.debounceClickHandler
      });
    }
  }]);
}(Component);

export { WelcomeBonus as default };